export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20boutique%20interior%20with%20soft%20pastel%20rose%20and%20sage%20tones%2C%20modern%20minimal%20shelving%20displaying%20curated%20accessories%20and%20apparel%2C%20warm%20diffused%20skylight%2C%20clean%20European%20aesthetic%2C%20architectural%20photography%2C%20serene%20luxury%20atmosphere%2C%20cream%20marble%20floors&width=1600&height=900&seq=hero-bg-v2&orientation=landscape"
          alt="Itaobuy Spreadsheet prodotti moda"
          title="Itaobuy Spreadsheet - prodotti e accessori moda"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 pt-32 pb-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="flex-1 text-center lg:text-left">
            <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-background-50 leading-tight font-heading">
              Itaobuy Spreadsheet:<br />
              <span className="italic font-normal">La Guida Italiana Completa</span>
            </h1>
            <p className="mt-6 text-base md:text-lg text-background-200 max-w-xl mx-auto lg:mx-0 font-body leading-relaxed">
              Scopri tutto quello che devi sapere su Itaobuy Spreadsheet: funzionalità, utilizzo, sicurezza, vantaggi, recensioni e consigli pratici per i tuoi acquisti online.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap font-label"
              >
                Itaobuy Sheet
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-900 text-background-50 rounded-full text-base font-semibold hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap font-label"
              >
                Buy It Now
                <i className="ri-shopping-bag-line"></i>
              </a>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-4 justify-center lg:justify-start">
              {['Guida aggiornata', 'Informazioni complete', 'Tutorial passo passo', 'Analisi indipendente'].map((badge) => (
                <span
                  key={badge}
                  className="inline-flex items-center gap-1.5 text-xs text-background-200 font-body"
                >
                  <i className="ri-check-line text-primary-400 text-sm"></i>
                  {badge}
                </span>
              ))}
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-3xl overflow-hidden h-[340px] md:h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=Luxury%20leather%20goods%20still%20life%20on%20warm%20sandstone%20surface%2C%20premium%20handbag%20and%20wallet%20with%20soft%20golden%20hour%20sunlight%2C%20rich%20cognac%20brown%20and%20cream%20tones%2C%20high%20end%20European%20editorial%20photography%2C%20elegant%20shadow%20play%2C%20sophisticated%20commercial%20aesthetic&width=800&height=600&seq=hero-side-v2&orientation=landscape"
                alt="Itaobuy Spreadsheet prodotti"
                title="Itaobuy Spreadsheet - collezione prodotti"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}